import {
    GET_RATED_SUCCESS,
    CALCULATING_RATING,
    GET_RATED_INCREMENT_STEP,
    GET_RATED_DECREMENT_STEP,
    GET_RATED_RESET_STEPS,
    SAVE_SURVEY_SUCCESS,
    USER_SELECTED_PROFILE,
    DISPOSE_OF_SURVEY } from '../actions';

const initialState = {
    currentStep: 1,
    survey: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case USER_SELECTED_PROFILE: {
            return {
                ...state,
                selectedProfile: action.profile,
            };
        }
        case SAVE_SURVEY_SUCCESS: {
            return {
                ...state,
                survey: action.survey,
            };
        }
        case CALCULATING_RATING: {
            return {
                ...state,
                calculating: action.isLoading,
            };
        }
        case GET_RATED_SUCCESS: // Same as save survey, refactor
            return {
                ...state,
                survey: action.user.selfRateSurvey,
            };
        case GET_RATED_INCREMENT_STEP: {
            return {
                ...state,
                currentStep: state.currentStep + 1,
            };
        }
        case GET_RATED_DECREMENT_STEP: {
            return {
                ...state,
                currentStep: state.currentStep > 1 ? state.currentStep - 1 : 1,
            };
        }
        case GET_RATED_RESET_STEPS: {
            return {
                ...state,
                currentStep: 1,
            };
        }
        case DISPOSE_OF_SURVEY: {
            return {
                ...state,
                survey: null,
                selectedProfile: null,
            };
        }
        default:
            return state;
    }
};
